import { SortCategoryId } from "../types";

export const CATEGORY_ITEMS_ORDER = {
  [SortCategoryId.TRADE_IDEAS]: [
    "RSI_TRADE_IDEAS",
    "ANALYST_TARGET_PRICE",
    "ANALYST_TARGET_PRICE_DAYS",
    "ANALYST_RATING",
    "EARNINGS_BUILD_UP",
    "EARNINGS_RESULTS",
    "INCOME_GENERATION",
    "RATING_CHANGE",
  ],
  [SortCategoryId.PERFORMANCE]: [
    "LARGEST_MARKET_OUT_PERFORMANCE",
    "PRICE_RETURN",
    "TOTAL_RETURN",
    "POTENTIAL_BREAK_OUTS",
    "POTENTIAL_BREAK_DOWNS",
    "AVERAGE_UP_DAYS",
    "AVERAGE_DOWN_DAYS",
    "UP_DAYS",
    "DOWN_DAYS",
  ],
  [SortCategoryId.RISK]: [
    "MARKET_IMPACT",
    "UPSIDE_IMPACT",
    "DOWNSIDE_IMPACT",
    "RISK_RETURN",
    "RISK_RETURN_VS_MARKET",
    "RISK_RETURN_CHANGE",
    "VOLATILITY_ANNUALISED",
    "VOLATILITY_CHANGE",
    "VOLATILITY_CHANGE_PERCENTAGE",
    "AVERAGE_VOL_MOVE",
    "CORRELATION",
    "CORRELATION_CHANGE",
  ],
  [SortCategoryId.TECHNICALS]: [
    "OVERBOUGHT_OVERSOLD",
    "RSI_WIN_PROBABILITY",
    "RSI_WIN_PRICE_CHANGE",
    "RSI_LOSS_PROBABILITY",
    "RSI_LOSS_PRICE_CHANGE",
    "RSI_FREQUENCY",
    "VOLUME_CHANGE",
    "DISTANCE_FROM_SIMPLE_MOVING_AVERAGE",
    "SIMPLE_MOVING_AVERAGE",
  ],
  [SortCategoryId.FUNDAMENTALS]: [
    "MARKET_CAPITALISATION",
    "DIVIDEND_YIELD",
    "EARNINGS_PER_SHARE_PROJECTED",
    "PRICE_TO_EARNINGS_PROJECTED",
    "EARNINGS_PER_SHARE_CURRENT",
    "PRICE_TO_BOOK_VALUE",
    "PEG_RATIO",
    "PRICE_SELLS_TTM",
  ],
  [SortCategoryId.OPTIONS]: [
    "OPTIONS_FEATURED_IDEAS",
    "OPTIONS_CALLS",
    "BONDS",
    "RUNNING_YIELD",
    "TIME_TO_MATURITY",
    "DURATION",
    "YIELD_TO_MATURITY",
    "YIELD_TO_CALL",
  ],
  [SortCategoryId.BONDS]: [
    "RUNNING_YIELD",
    "TIME_TO_MATURITY",
    "DURATION",
    "YIELD_TO_MATURITY",
    "YIELD_TO_CALL",
  ],
  [SortCategoryId.ALERTS]: [
    "DAILY_MOVE",
    "VOLATILITY_30_DAYS",
    "ALERT_RISK_RETURN",
    "ALERT_OVERBOUGHT_AND_SOLD",
    "ALERT_OPTIONS_VOLUME_CHANGE_CALLS_AT_THE_MONEY",
    "ALERT_OPTIONS_VOLUME_CHANGE_PUTS_MONEY",
  ],
  [SortCategoryId.EARNINGS]: [
    "EARNINGS_EPS_SURPRISE_WIN_PROBABILITY",
    "EARNINGS_BUILD_UP_WIN_PROBABILITY",
    "EARNINGS_AFTER_RESULTS_WIN_PROBABILITY",
    "EARNINGS_BUILD_UP_WIN_PRICE_COVERAGE",
    "EARNINGS_AFTER_RESULTS_WIN_PRICE_COVERAGE",
    "EARNINGS_DAYS",
  ],
};
